import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useApolloClient } from '@apollo/client';

import { accountsClient } from 'src/utils/account';
import { setToken } from 'src/reducers/user/userReducer';
import { PATHS } from 'src/constants/paths';
import { Box, Spinner } from 'grommet';

function LogoutPage(): JSX.Element {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const client = useApolloClient();

  useEffect(() => {
    (async () => {
      try {
        await accountsClient.logout();
      } catch (e) {
        navigate(-1);
      }
      dispatch(setToken(undefined));
      client.clearStore();
      navigate(PATHS.LOGIN, { replace: true });
    })();
  }, [client, dispatch, navigate]);

  return (
    <Box align='center' justify='center' direction='row' height={{ min: '100vh' }}>
      <Spinner size='medium' />
    </Box>
  );
}

export default LogoutPage;
